{
  "en": {
    "incognito": {
      "signedInAs": "Signed in as",
      "stop": "Exit"
    }
  }
}
